import {
  TbAntennaBars1,
  TbAntennaBars2,
  TbAntennaBars3,
  TbAntennaBars4,
  TbAntennaBars5,
} from 'react-icons/tb'

export const PRIORITY_ICONS = [
  { Icon: TbAntennaBars1, color: 'text-muted-foreground' },
  { Icon: TbAntennaBars2, color: 'text-blue-500' },
  { Icon: TbAntennaBars3, color: 'text-yellow-500' },
  { Icon: TbAntennaBars4, color: 'text-orange-500' },
  { Icon: TbAntennaBars5, color: 'text-red-500' },
]
